import { render, staticRenderFns } from "./BrowserCompatibility.component.html?vue&type=template&id=3a060b20&scoped=true&"
import script from "./BrowserCompatibility.component.ts?vue&type=script&lang=ts&"
export * from "./BrowserCompatibility.component.ts?vue&type=script&lang=ts&"
import style0 from "./BrowserCompatibility.component.scss?vue&type=style&index=0&id=3a060b20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a060b20",
  null
  
)

export default component.exports